<template>
  <div class="audit-page" v-title data-title="全部课程|卓考网校课程试听">
    <header class="g-header-container">
      <c-header title="全部课程" />
    </header>

    <main class="g-view-container">
      <div class="course-list">
        <course-item
          v-for="(item, index) in list"
          :key="index"
          v-bind="item"
          @click.native="toCourse(item.listenIndexId)"
        />
      </div>
    </main>

    <footer class="g-footer-container">
      <a
        class="license"
        href="https://files.zhuokao360.com/mall/publication-license.jpg"
        target="_blank"
      >
        出版物经营许可证
      </a>
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import CHeader from 'components/header';
  import CourseItem from './course-item';

  export default {
    name: 'Audit',
    components: {
      CHeader,
      CourseItem,
    },
    data() {
      return {
        list: [],
      };
    },
    created() {
      this.showLoading();

      this.getList().then(({ data: { code, data } }) => {
        if (code === 200) {
          this.hideLoading();
          this.list = data;
        }
      });
    },
    methods: {
      // 获取试听课程列表
      getList() {
        return axios.get('https://api.zhuokao360.com/listen/findListenIndex');
      },

      // 跳转课程试听页面
      toCourse(listenIndexId) {
        this.$router.push({
          name: 'auditDetail',
          params: {
            listenIndexId,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
/* 课程列表 */
.course-list {
  display: flex;
  flex-direction: column;
  padding: 24px 12px;
}

/* 底部许可证 */
.g-footer-container .license {
  display: block;
  font-size: 14px;
  color: #fff;
  line-height: 100px;
  text-align: center;
  background-color: #475050;
}
</style>
